import { client } from "./API";
import { factorsObj } from "../models/WinProbabilityFactorModel";

const WPFService = {
  async getWinFactorQuestions() {
    try {
      const response = await client({
        url: "Wpquestion/GetWpquestionsAndOptions",
        method: "get",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.log(error);
      return [];
    }
  },
  async postWinFactorOptions(projectId: number, options: factorsObj) {
    try {
      const response = await client({
        url: `Wpquestion/PostWpSelectedOptions/${projectId}`,
        method: "post",
        data: options,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async getProjectWinFactorQuestions(projectId: number) {
    try {
      const response = await client({
        url: `Wpquestion/GetWpquestionsAndSelectedOptions/${projectId}`,
        method: "get",
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default WPFService;
